module.exports = __webpack_public_path__ + "static/media/SFUIDisplay-Medium.40370a7c.ttf";